export default __webpack_public_path__ + "static/media/cv.3178913c.jpg";